import React, { Component, PropTypes } from 'react'

import Indicator from 'components/Common/Indicator'
import Consult from 'components/Common/Consult'

import ReportGraph from 'components/Report/ReportGraph'
import AnswerList from 'components/Report/AnswerList'

import { getReport } from 'common/api'

import styles from './index.css'


function getScrollTop () {
  return scrollY
    || document.documentElement.scrollTop
    || document.body.scrollTop
}


class Report extends Component {
  static childContextTypes = {
    openConsult: PropTypes.func.isRequired
  }

  constructor () {
    super()
    this.state = {
      graphInfo: {
        count: 0,
        time: 0,
        percent: 0
      },
      answers: [],
      current: 0,
      showConsult: false,
      fixed: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.openConsult = this.openConsult.bind(this)
    this.closeConsult = this.closeConsult.bind(this)
  }

  getChildContext () {
    return {
      openConsult: this.openConsult
    }
  }

  componentDidMount () {
    const exerciseId = this.props.location.query.exerciseId

    getReport(exerciseId)
    .then(({ answers, time }) => {
      const count = answers.length
      const percent = Math.ceil(answers.filter(answer => answer.isCorrect).length / count * 100)

      this.setState({
        answers,
        graphInfo: {
          time,
          count,
          percent
        }
      })
    })
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', this.handleScroll)
  }

  closeConsult () {
    this.setState({
      showConsult: false
    })
  }

  openConsult () {
    this.setState({
      showConsult: true
    })
  }

  handleScroll () {
    if (getScrollTop() > 333) {
      this.setState({
        fixed: true
      })
    } else {
      this.setState({
        fixed: false
      })
    }
  }

  handleChange (current) {
    const height = this.refs.indicator.clientHeight

    this.setState({ current })
    location.hash = current + 1
    document.documentElement.scrollTop = getScrollTop() - height
    document.body.scrollTop = getScrollTop() - height
  }

  render () {
    const {
      graphInfo, answers, current, showConsult, fixed
    } = this.state
    const statuses = answers.map(answer => answer.isCorrect)
    return (
      <div className={styles.root}>
        <Consult show={showConsult} onClose={this.closeConsult} />
        <ReportGraph {...graphInfo} />
        <div
          style={{
            position: fixed ? 'fixed' : 'relative',
            padding: fixed ? '0 100px' : ''
          }}
          className={styles.indicator}
          ref="indicator"
        >
          <Indicator
            statuses={statuses}
            current={current}
            onChange={this.handleChange}
          />
        </div>
        <AnswerList answers={answers} />
      </div>
    )
  }
}


export default Report



/** WEBPACK FOOTER **
 ** ./src/pages/Report/index.js
 **/